<template>
    <div class="h-100 pb-100">
        <b-row class="h-100 bg-grey">
            <b-col class="bg-white" cols="3">

                <div class="pt-4" v-if="item.applicationId">
                    <h2>Edit app</h2>
                    <p>Review and edit your app.</p>
                    <p>View your Client ID and Client Secret here to authenticate with our API. More info is on the
                        documentation website here:</p>


                    <hr class="my-5">

                </div>
            </b-col>
            <b-col>
                <div class="d-flex flex-wrap align-content-between" v-if="item.applicationId">
                    <b-form class="pt-4 w-75">
                        <b-form-group
                                label="Name:"
                                label-size="sm"
                        >
                            <b-form-input
                                    placeholder="App name"
                                    v-model="item.name"
                            ></b-form-input>
                            <div>
                                <small>Name your app based on what role it will fulfill e.g. Contractor App OAuth</small>
                            </div>
                        </b-form-group>

                        <b-form-group
                                label="Description:"
                                label-size="sm"
                        >
                            <b-form-textarea
                                    placeholder="Describe what your app does"
                                    v-model="item.description"
                            ></b-form-textarea>
                            <div>
                                <small>Describe what your application will do</small>
                            </div>
                        </b-form-group>

                        <b-form-group
                                label="Client ID:"
                                label-size="sm"
                        >
                            <b-form-input
                                    :value="item.auth0.client_id"
                                    readonly
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label="Client Secret:"
                                label-size="sm"
                        >
                            <b-form-input
                                    :value="item.auth0.client_secret"
                                    readonly
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label="Allowed Callback URLs:"
                                label-size="sm"
                        >
                            <b-form-textarea
                                    v-model="callbacks"
                            ></b-form-textarea>
                            <div>
                                <small>You can have multiple callback urls, separated by comma</small>
                            </div>
                        </b-form-group>

                        <b-form-group
                                label="Allowed Logout URLs:"
                                label-size="sm"
                        >
                            <b-form-textarea
                                    v-model="logoutUrls"
                            ></b-form-textarea>
                            <div>
                                <small>You can have multiple logout urls, separated by comma</small>
                            </div>
                        </b-form-group>

                        <b-form-group v-if="requests.length > 2">
                            <Statistic-Widget statistic="Number of Requests"
                                              :chartData="chartData"
                                              v-if="chartData"
                            >
                            </Statistic-Widget>
                        </b-form-group>
                    </b-form>

                </div>

            </b-col>
            <b-col cols="2">
                <div class="mt-4 d-flex justify-content-end">
                    <b-btn :to="{ name: 'apps' }"
                           class="mb-3"
                           size="sm"
                           variant="primary">
                        Back to your apps
                        <font-awesome-icon
                                :icon="['far', 'arrow-right']"
                                class="ml-2">
                        </font-awesome-icon>
                    </b-btn>
                </div>
            </b-col>
            <vue-element-loading :active="loading"/>
        </b-row>
        <div class="form-footer fixed-bottom">
            <b-btn @click="update"
                   class="ml-auto"
                   variant="primary">
                Save
            </b-btn>
        </div>
    </div>

</template>

<script>
import Applications from '@/services/Apps/Applications';
import StatisticWidget from '@/components/Widgets/StatisticWidget';

export default {
  name: 'View-App',
  components: {
    StatisticWidget,
  },
  data() {
    return {
      item: [],
      loading: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    requests() {
      const { statistics } = this.item;

      if (!statistics) {
        return [];
      }

      return statistics
        .filter(row => row.statistic === 'requests');
    },
    chartData() {
      const timestamps = this.requests.map(row => row.timestamp);
      const data = this.requests.map(row => row.result);

      return {
        labels: timestamps,
        datasets: [
          {
            label: this.item.name,
            backgroundColor: '#f87979',
            borderColor: '#f87979',

            fill: false,
            data,
          },
        ],
      };
    },
    callbacks: {
      get() {
        const { callbacks } = this.item.auth0;

        if (!callbacks || callbacks.length === 0) {
          return '';
        }

        return callbacks.join(',');
      },
      set(values) {
        this.item.auth0.callbacks = values.split(',');
      },
    },
    logoutUrls: {
      get() {
        const { allowed_logout_urls } = this.item.auth0;

        if (!allowed_logout_urls || allowed_logout_urls.length === 0) {
          return '';
        }

        return allowed_logout_urls.join(',');
      },
      set(values) {
        this.item.auth0.callbacks = values.split(',');
      },
    },
  },
  async mounted() {
    await this.fetchItem();
  },
  methods: {
    async fetchItem() {
      this.loading = true;

      try {
        const { data } = await Applications.get(this.id);
        this.item = data.data;
      } catch (e) {
        this.$notify({
          duration: 5000,
          title: 'Unable to fetch your app',
          text: 'Unable to get your app at this time. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
    async update() {
      this.loading = true;

      const { name, description } = this.item;
      const { callbacks } = this.item.auth0;

      const params = {
        name,
        description,
        callbacks,
      };

      try {
        await Applications.update(this.id, params);
        await this.fetchItem();

        this.$notify({
          duration: 5000,
          title: 'App updated',
          type: 'success',
        });
      } catch (e) {
        this.$notify({
          duration: 5000,
          title: 'Unable to update your app',
          text: 'Unable to get your app at this time. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
